<template>
  <h1 v-if="props.weight === 'h1'">
    <slot />
  </h1>
  <h2 v-else-if="props.weight === 'h2'">
    <slot />
  </h2>
  <h3 v-else-if="props.weight === 'h3'">
    <slot />
  </h3>
</template>

<script setup lang="ts">
const props = defineProps<{
  weight: 'h1' | 'h2' | 'h3'
}>()
</script>
